import { combineReducers } from 'redux';
import { reducers as favorites } from '@fenderdigital/favorites';
import courses from './courses';
import fenderConnect from './fender-connect';
import flags from './flags';
import intl from './intl';
import layout from './layout';
import leads from './leads';
import lessons from './lessons';
import myPath from './my-path';
import myProgress from './my-progress';
import pages from './pages';
import paths from './paths';
import payWall from './payWall';
import plans from './plans';
import practice from './practice';
import pricing from './pricing';
import onboarding from './onboarding';
import relatedItems from './related-items';
import runtime from './runtime';
import search from './search';
import session from './session';
import skills from './skills';
import skillsLists from './skills-lists';
import song from './song';
import songsLists from './songs-lists';
import stats from './stats';
import streaks from './streaks';

const makeRootReducer = asyncReducers =>
  combineReducers({
    ...asyncReducers,
    courses,
    favorites,
    fenderConnect,
    intl,
    layout,
    leads,
    lessons,
    myPath,
    myProgress,
    onboarding,
    pages,
    paths,
    payWall,
    plans,
    practice,
    pricing,
    relatedItems,
    runtime,
    search,
    session,
    skills,
    skillsLists,
    song,
    songsLists,
    stats,
    streaks,
    flags,
  });

export const injectAsyncReducer = (store, key, reducer) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  /* eslint-disable no-param-reassign */
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
